import {ChangeDetectorRef, Component, Input} from '@angular/core';
import { HttpClient } from "@angular/common/http";
import {Compbaser} from "../../../components/compbaser/compbases";
import * as Highcharts from 'highcharts';
import {fadeTransition} from 'libs/basicTransition';

@Component({
    selector: 'app-resource-avg',
    templateUrl: './resource-avg.component.html',
    styleUrls: ['./resource-avg.component.scss'],
    animations: [fadeTransition]
})
export class ResourceAvgComponent extends Compbaser {
    _options;
    _chart: any;
    _ready = false;
    Highcharts: typeof Highcharts = Highcharts;
    chartOptions: Highcharts.Options;

    @Input() set resources(i_resources) {
        this.initGrapha(i_resources);
    }

    constructor(private _http: HttpClient, private cd: ChangeDetectorRef) {
        super();
    }

    logChartInstance(chart: Highcharts.Chart) {
        this._chart = chart;
    }

    chartCallback = (chart) => {
        setTimeout(() => {
            if (!chart || !chart.callback || chart.callback.length == 0) return;
            chart.reflow();
        }, 1);
    };

    initGrapha(i_resources) {
        this._options = {
            chart: {
                height: 200,
                inverted: true,
                marginLeft: 100,
                marginTop: 50,
                type: 'bullet'
            },
            title: {
                text: ''
            },
            legend: {
                enabled: false
            },
            plotOptions: {
                series: {
                    pointPadding: 0.25,
                    borderWidth: 0,
                    color: '#000',
                    targetOptions: {
                        width: '200%'
                    }
                }
            },
            credits: {
                enabled: false
            },
            xAxis: {
                categories: ['<span class="hc-cat-title">Videos</span>', '<span class="hc-cat-title">Images</span>', '<span class="hc-cat-title">other files</span>']
            },
            series: [{
                data: [
                    {
                        y: i_resources.videos,
                        target: i_resources.max,
                        color: '#bbb'
                    },
                    {
                        y: i_resources.images,
                        target: i_resources.max,
                        color: '#6451bb'
                    },
                    {
                        y: i_resources.other,
                        target: i_resources.max,
                        color: '#b4bb35'
                    }]
            }],
            tooltip: {
                enabled: false
            }
            // tooltip: {
            //     pointFormat: '<b>{point.y}</b> (with target at {point.target})'
            // },
            // tooltip: {
            //     headerFormat: `<span style="color: {series.color} !important">{point.key}</span><table style="color: white">`,
            //     pointFormat: `<tr><td style="color:  {series.color};padding:0">{series.name}: </td><td style="padding:0; color:  {series.color}"><b><span style="color:  {series.color}">{point.y:.1f} </span></b></td></tr>`,
            //     footerFormat: '</table>',
            //     shared: true,
            //     useHTML: true
            // }
        };
        this.chartOptions = this._options;
        setTimeout(() => {
            this._ready = true;
        }, 6);
    }

    onSelect(event) {
        console.log(event);
    }
}

